import { useStaticQuery, graphql } from "gatsby";

export const GetCaseStudiesData = () => {
  const data = useStaticQuery(graphql`
    query {
      allWpCaseStudy {
        nodes {
          databaseId
          slug
          caseStudyTitle
          caseStudyFields {
            heroDescription
            heroImage {
              node {
                localFile {
                  childImageSharp {
                    gatsbyImageData
                  }
                }
                mediaItemUrl
              }
            }
            parentProject {
              nodes {
                slug
              }
            }
          }
        }
      }
    }
  `);

  return data.allWpCaseStudy.nodes;
};
